import { PANEL_WIDTH, SETTING_PANEL_TABS } from '@/constants/settingPanels';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAppStore = defineStore('app', () => {
  const loading = ref(false);
  const loadingDisplayText = ref(null);
  const displayLoadingToast = ref(false);
  const progress = ref(0);
  const progressDisplayText = ref(null);

  // Panel Settings

  const rightSelectedTab = ref(SETTING_PANEL_TABS.TREE_VIEW);
  const rightSettingPanelWidth = ref(PANEL_WIDTH.RIGHT_MAX);
  const leftSettingPanelWidth = ref(PANEL_WIDTH.LEFT_MIN);
  const treeParameterPanelOpen = ref(false);
  const treeDisplayOnlyIcon = ref(false);
  const treeObjectCloningInProgress = ref(false);
  const treeParentDragOver = ref(false);

  const setLoading = (value) => {
    loading.value = value;
  };
  const setDisplayText = (value) => {
    loadingDisplayText.value = value ? value : '';
  };

  const setProgress = (value) => {
    progress.value = value;
  };

  const setProgressDisplayText = (value) => {
    progressDisplayText.value = value;
  };

  const setDisplayLoadingToast = (value) => {
    displayLoadingToast.value = value;
  };

  const setRightSelectedTab = (value) => {
    rightSelectedTab.value = value;
  };

  const setRightSettingPanelWidth = (value) => {
    rightSettingPanelWidth.value = value;
  };

  const setLeftSettingPanelWidth = (value) => {
    leftSettingPanelWidth.value = value;
  };

  const setTreeParameterPanelOpen = (value) => {
    treeParameterPanelOpen.value = value;
  };

  const setTreeDisplayOnlyIcon = (value) => {
    treeDisplayOnlyIcon.value = value;
  };

  const setTreeObjectCloningInProgress = (value) => {
    treeObjectCloningInProgress.value = value;
  };
  const setTreeParentDragOver = (value) => {
    treeParentDragOver.value = value;
  };

  return {
    loading,
    loadingDisplayText,
    progress,
    progressDisplayText,
    displayLoadingToast,
    rightSelectedTab,
    rightSettingPanelWidth,
    leftSettingPanelWidth,
    treeParameterPanelOpen,
    treeDisplayOnlyIcon,
    treeObjectCloningInProgress,
    treeParentDragOver,
    setLoading,
    setDisplayText,
    setProgress,
    setProgressDisplayText,
    setDisplayLoadingToast,
    setRightSelectedTab,
    setRightSettingPanelWidth,
    setLeftSettingPanelWidth,
    setTreeParameterPanelOpen,
    setTreeDisplayOnlyIcon,
    setTreeObjectCloningInProgress,
    setTreeParentDragOver,
  };
});
